import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Features from '../sections/Features/Features';
import SEO from '../components/SEO';

const FeaturesPage = ({ lang = 'en' }) => {
  const BASE_URL = "https://alsaketdental.com";
  const SITE_NAME = "AlSaket Dental Clinics";
  const SITE_NAME_AR = "عيادات الساكت لطب الأسنان";

  const isArabic = lang === 'ar';
  const pageUrl = `${BASE_URL}/${lang}/features`;

  // JSON-LD: Features Page
  const featuresPageLD = {
    "@context": "https://schema.org",
    "@type": "MedicalBusiness",
    "name": "AlSaket Dental Clinics Features",
    "alternateName": "مميزات عيادات الساكت لطب الأسنان",
    "url": pageUrl,
    "description": "Discover the advanced features and modern technologies at AlSaket Dental Clinics. Safety-first approach, insurance acceptance, full-service dentistry, and judgment-free care.",
    "description_ar": "اكتشف المميزات المتقدمة والتقنيات الحديثة في عيادات الساكت لطب الأسنان. نهج السلامة أولاً، قبول التأمين، طب الأسنان الشامل، والرعاية الخالية من الأحكام.",
    "feature": [
      {
        "@type": "MedicalBusiness",
        "name": "Safety First",
        "name_ar": "السلامة أولاً",
        "description": "We prioritize safety with comprehensive health checks and advanced safety protocols."
      },
      {
        "@type": "MedicalBusiness",
        "name": "Insurance Accepted", 
        "name_ar": "قبول التأمين",
        "description": "We're in network with major insurers. Check your insurance coverage in our insurance section."
      },
      {
        "@type": "MedicalBusiness",
        "name": "Full-Service Dentistry",
        "name_ar": "طب الأسنان الشامل",
        "description": "Our clinic offers a full range of dental services, from exams to implants and veneers."
      },
      {
        "@type": "MedicalBusiness",
        "name": "No Judgment Ever",
        "name_ar": "بدون أحكام أبداً",
        "description": "From floss bosses to sweet tooths, every mouth is welcome in our judgment-free environment."
      }
    ]
  };

  return (
    <>
      <SEO
        title="Dental Clinic Features - AlSaket Dental Clinics"
        titleAr="مميزات عيادات الأسنان - عيادات الساكت"
        description="Discover the advanced features and modern technologies at AlSaket Dental Clinics in Amman, Jordan. Safety-first approach, insurance acceptance, and comprehensive dental care."
        descriptionAr="اكتشف المميزات المتقدمة والتقنيات الحديثة في عيادات الساكت لطب الأسنان في عمان، الأردن. نهج السلامة أولاً، قبول التأمين، والرعاية الشاملة للأسنان."
        keywords={[
          "dental clinic features amman", 
          "modern dental technology jordan", 
          "safe dental care amman", 
          "dental insurance amman",
          "full service dentistry jordan",
          "professional dental clinic amman",
          "advanced dental equipment amman",
          "comprehensive dental care jordan"
        ]}
        keywordsAr={[
          "مميزات عيادات الأسنان عمان", 
          "تقنيات طب الأسنان الحديثة الأردن", 
          "رعاية أسنان آمنة عمان", 
          "تأمين الأسنان عمان",
          "طب الأسنان الشامل الأردن",
          "عيادة أسنان مهنية عمان",
          "معدات طب الأسنان المتقدمة عمان",
          "رعاية أسنان شاملة الأردن"
        ]}
        url={pageUrl}
        image={`${BASE_URL}/images/features-og-image.jpg`}
        siteName={SITE_NAME}
        siteNameAr={SITE_NAME_AR}
        structuredData={[featuresPageLD]}
        lang={isArabic ? 'ar' : 'en'}
      />
      
      <Navbar />
      <Features />
      <Footer />
    </>
  );
};

export default FeaturesPage;
